import * as isNil from 'lodash/isNil';

import { AdditionOperator } from './addition-operator';
import { DivisionOperator } from './division-operator';
import { FactOperator } from './fact-operator';
import { MultiplicationOperator } from './multiplication-operator';
import { SubtractionOperator } from './subtraction-operator';

/**
 * Converts string input to respective FactOperator.
 */
export class FactOperatorBuilder {

	public static build(type: string): FactOperator {
		if (!isNil(type)) {
			switch (type) {
				case 'add':
					return new AdditionOperator();
				case 'subtract':
					return new SubtractionOperator();
				case 'divide':
					return new DivisionOperator();
				case 'multiply':
					return new MultiplicationOperator();
				default:
					throw new Error('FactOperator not valid.');
			}
		}
		return null; // this means fact operator is not provided
	}
}
